import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

const CameraFlashLoader = () => {
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    const INTERVAL = 600; // speed of shots
    const flashInterval = setInterval(() => {
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 300);
    }, INTERVAL);

    return () => clearInterval(flashInterval);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'transparent',
      }}
    >
      {/* Camera */}
      <Box
        sx={{
          position: 'relative',
          width: 280,
          height: 180,
          borderRadius: 2,
          background:
            'linear-gradient(300deg, #8a471d 0%, #8a471d 40%, #208cb0 90%, #208cb0 100%)',
          boxShadow: '0 6px 20px rgba(0,0,0,0.6)',
          border: '2px solid #555',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -20,
            left: 0,
            width: '100%',
            height: 20,
            background: '#fcd4bb',
            borderTopLeftRadius: 1,
            borderTopRightRadius: 1,
          },
          animation: isFlashing ? 'shake 0.3s ease-in-out' : 'none',
        }}
      >
        {/* Shutter Button */}
        <Box
          sx={{
            position: 'absolute',
            top: -28,
            right: 20,
            width: 28,
            height: 14,
            background: '#8a471d',
            borderRadius: 1,
            boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
          }}
        />

        {/* Viewfinder */}
        <Box
          sx={{
            position: 'absolute',
            top: 20,
            left: 20,
            width: 30,
            height: 20,
            background: '#000',
            border: '2px solid #208cb0',
            borderRadius: 0.5,
          }}
        />

        {/* Lens Container */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 130,
            height: 130,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* Rotating Ring */}
          <Box
            sx={{
              position: 'absolute',
              width: 130,
              height: 130,
              borderRadius: '50%',
              borderTop: '4px solid #fcd4bb',
              animation: 'rotate-ring 1.5s linear infinite',
            }}
          />

          {/* Lens */}
          <Box
            sx={{
              width: 110,
              height: 110,
              borderRadius: '50%',
              background:
                'radial-gradient(circle at center, #000 20%, #222 40%, #555 70%, #222 100%)',
              border: '2px solid #fcd4bb',
              boxShadow:
                'inset 0 0 20px rgba(255,255,255,0.2), 0 0 10px rgba(0,0,0,0.8)',
              position: 'relative',
              zIndex: 1,
              '&::after': {
                content: '""',
                position: 'absolute',
                top: '20%',
                left: '25%',
                width: '40%',
                height: '20%',
                background: 'rgba(255,255,255,0.3)',
                borderRadius: '50%',
                transform: 'rotate(-20deg)',
              },
            }}
          />
        </Box>

        {/* Flash */}
        <Box
          sx={{
            position: 'absolute',
            top: 15,
            right: 15,
            width: 55,
            height: 30,
            background: '#f5e9df',
            border: '3px solid #bd5d2a',
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: -3,
              background: '#fff',
              borderRadius: '50%',
              filter: 'blur(25px)',
              boxShadow: '0 0 80px 40px rgba(255,255,200,0.9)',
              opacity: isFlashing ? 1 : 0,
              animation: isFlashing ? 'flash-blink 0.15s ease-in-out' : 'none',
            }}
          />
        </Box>
      </Box>

      {/* Text below camera */}
      <Typography
        sx={{
          mt: 3,
          fontSize: 24,
          fontWeight: 'bold',
          // color: "#8a471d",
          textAlign: 'center',
          fontStyle: 'italic',
        }}
      >
        SnapCity Loading...
      </Typography>

      {/* Keyframes */}
      <style>
        {`
          @keyframes flash-blink {
            0% { opacity: 0; }
            20% { opacity: 1; }
            70% { opacity: 1; }
            100% { opacity: 0; }
          }

          @keyframes shake {
            0% { transform: translate(0, 0) rotate(0deg); }
            20% { transform: translate(-3px, 2px) rotate(-1deg); }
            40% { transform: translate(3px, -2px) rotate(1deg); }
            60% { transform: translate(-2px, 1px) rotate(0deg); }
            80% { transform: translate(2px, -1px) rotate(1deg); }
            100% { transform: translate(0, 0) rotate(0deg); }
          }

          @keyframes rotate-ring {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default CameraFlashLoader;
